module.exports = __webpack_public_path__ + "img/AdjustOutlined.caa060ff.svg";